<template>
    <div 
        v-show="isDialogVisible" 
        id="dialog">
        <div class="wrap">
            <div 
                v-if="dialogType == 'rules'" 
                key="rules" 
                ref="refInner" 
                class="inner rules">
                <p class="title">{{ $attrs.title }}</p>
                <div 
                    class="rules-text" 
                    v-html="$attrs.rules"/>
            </div>
            <div 
                v-show="isBtnShow" 
                ref="refClose" 
                class="close" 
                @click="close"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "DialogComp",
    data () {
        return {
            isDialogVisible: false,
            dialogType: "rules",
            isBtnShow: true,
            clientHeight: document.documentElement.clientHeight
        };
    },
    mounted() {
        // 处理部分安卓 掉起软键盘输入后 元素定位位置变动问题
        window.onresize = () => {
            if (this.clientHeight > document.documentElement.clientHeight) {
                this.isBtnShow = false;
            } else {
                this.isBtnShow = true;
            }
        };
    },
    methods: {
        show() {
            this.isDialogVisible = true;
        },
        close() {
            this.isDialogVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';

@-webkit-keyframes scale-up-center {
  0% {
    -webkit-transform:translate(-50%, -50%) scale(0.5);
            transform:translate(-50%, -50%) scale(0.5);
  }
  100% {
    -webkit-transform:translate(-50%, -50%) scale(1);
            transform:translate(-50%, -50%) scale(1);
  }
}
@keyframes scale-up-center {
  0% {
    -webkit-transform:translate(-50%, -50%) scale(0.5);
            transform:translate(-50%, -50%) scale(0.5);
  }
  100% {
    -webkit-transform:translate(-50%, -50%) scale(1);
            transform:translate(-50%, -50%) scale(1);
  }
}

#dialog {
  z-index: 11;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .85);
}
.wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  width: vws(532px + 53px + 53px);
  height: vws(657px + 43px);
  transform:translate(-50%, -50%);
  background: #FFFFFF;
  border-radius: vws(24px);
  -webkit-animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
          animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  .rules {
    margin: 0 auto;
    width: vws(532px);
    height: vws(657px);
    overflow-y: scroll;
    word-break: break-all;
    color: #4A2525;
    &::-webkit-scrollbar {
      display: none;
      width: 0;
    }
  }
  .title {
      margin-top: vws(41px);
      margin-bottom: vws(25px);
      font-size: vws(34px);
      font-weight: bold;
      text-align: center;
  }
  .rules-text {
    color: #422222;
    font-size: vws(24px);
    text-align: left;
  }
}
.close {
  position: relative;
  margin: 0 auto;
  margin-top: vws(93px);
  width: vws(58px);
  height: vws(58px);
  border: 1px solid #fff;
  border-radius: 50%;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    width: vws(20px);
    height: 1px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    width: vws(20px);
    height: 1px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(45deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202102/link_vip/comp/Dialog.vue